import React from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon } from 'lucide-react';
const NavigationHeader = () => {
  return <header className="w-full bg-white shadow-sm" data-id="element-35">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-36">
        <Link to="/" className="flex items-center" data-id="element-37">
          <h1 className="text-2xl font-bold text-teal-600" data-id="element-38">beautii.co</h1>
        </Link>
        <nav className="hidden md:flex space-x-8" data-id="element-39">
          <Link to="/" className="text-gray-700 hover:text-teal-600 font-medium" data-id="element-40">
            Home
          </Link>
          <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium" data-id="element-41">
            Services
          </Link>
          <a href="#" className="text-gray-700 hover:text-teal-600 font-medium" data-id="element-42">
            About
          </a>
          <a href="#" className="text-gray-700 hover:text-teal-600 font-medium" data-id="element-43">
            Contact
          </a>
        </nav>
        <div className="md:hidden" data-id="element-44">
          <button className="p-2" data-id="element-45">
            <MenuIcon className="h-6 w-6 text-gray-700" data-id="element-46" />
          </button>
        </div>
      </div>
    </header>;
};
export default NavigationHeader;